import AutoSourcingRule from './model';
import { AutoSourcingRuleMap } from './reducer';

export const ADD_MULTIPLE = 'entities/autoSourcingRule/ADD_MULTIPLE';
export const UPDATE = 'entities/autoSourcingRule/UPDATE';
export const ADD = 'entities/autoSourcingRule/ADD';

export const addMultipleAction = (autoSourcingRules: AutoSourcingRuleMap) => ({
  type: ADD_MULTIPLE,
  autoSourcingRules,
});

export const updateAction = (autoSourcingRule: AutoSourcingRule) => ({
  type: UPDATE,
  autoSourcingRule,
});

export const addAction = (autoSourcingRule: AutoSourcingRule) => ({
  type: ADD,
  autoSourcingRule,
});
